/**
 * DetailFactsChannelText atom — channel name on the detail facts line (bold).
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const DetailFactsChannelText = styled.span`
  color: ${Colors['text']};
  font-family: ${Fonts['bold']};
  font-size: ${32 * Screen.widthRatio}px;
  line-height: ${40 * Screen.widthRatio}px;
`;

export default DetailFactsChannelText;
